import {Pipe, PipeTransform} from '@angular/core';
import {formatDate} from '../utilities/date-util';

/**
 * Formats a date using the app's moment-style tokens (see date-util).
 *   L    - 11/17/2016
 *   LLL  - not supported (unused); add to date-util if needed
 * Pipe name kept as 'moment' so existing templates ({{ x | moment:FMT }}) are unchanged.
 */
@Pipe({
    name: 'moment',
    standalone: false
})
export class DatePipe implements PipeTransform {
  transform(value: string | Date, format: string): string {
    return formatDate(value, format);
  }
}
